import React, { useState,useEffect } from 'react';
import styled from 'styled-components';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Section,Title,StyledCard } from './Section';
import { makeGetRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';
import { IMAGE_BASE_URL } from '../constants/paths';

const MinistriesSection = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};
  const [ministries,setMinistries] = useState([])
   const [isLoading,setIsLoading] = useState(true)
  const [serverError,setServerError] = useState(null)

  


    

   const getMinistries = async()=>{
            setIsLoading(true)
            const res = await makeGetRequest('ministries/'+church.id)
            if(res && res.errorType){
                setIsLoading(false)
                const errorMessage = ErrorHandler(res)
                setServerError(errorMessage)
                
            }else{
              if(Array.isArray(res.data)){
                setMinistries(res.data)
                 setServerError(null)
                setIsLoading(false);
  
              }else {
            console.warn('Expected an array, but got:', res.data);
          }
               
            }
    
        }
        useEffect(()=>{
            getMinistries();
        },[])

  return (
    <Section>
      <Container>
        <Title>Our Ministries</Title>
        <Row>
          {ministries.map((ministry, index) => (
            <Col md={4} key={index} className="mb-4">
              <StyledCard>
              <Card.Img variant="top" src={`${IMAGE_BASE_URL}${ministry.photo}`} crossorigin="anonymous"/>            
                
                <Card.Body>
                  <Card.Title>{ministry.name}</Card.Title>
                  <Card.Text>{ministry.description}</Card.Text>
                </Card.Body>
              </StyledCard>
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  );
};

export default MinistriesSection;
